import {
  gfmStrikethroughFromMarkdown,
  gfmStrikethroughToMarkdown,
} from "mdast-util-gfm-strikethrough"
import { gfmTableFromMarkdown, gfmTableToMarkdown } from "mdast-util-gfm-table"
import { gfmStrikethrough } from "micromark-extension-gfm-strikethrough"
import { gfmTable } from "micromark-extension-gfm-table"

type ProcessorData = {
  micromarkExtensions?: unknown[]
  fromMarkdownExtensions?: unknown[]
  toMarkdownExtensions?: unknown[]
}

/**
 * The parts of remark-gfm the coach uses: tables and strikethrough.
 * remark-gfm itself must stay out: its autolink-literal transform builds a
 * lookbehind regex that throws "invalid group specifier name" in Safari before
 * 16.4 and takes the whole page down on older iPads.
 */
export function remarkGfmOhneAutolinks(this: { data: () => unknown }) {
  const data = this.data() as ProcessorData
  ;(data.micromarkExtensions ??= []).push(gfmTable(), gfmStrikethrough())
  ;(data.fromMarkdownExtensions ??= []).push(
    gfmTableFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
  )
  ;(data.toMarkdownExtensions ??= []).push(
    gfmTableToMarkdown(),
    gfmStrikethroughToMarkdown(),
  )
}
